import React from 'react';

const Results = () => (
  <div style={{ padding: 32 }}>
    <h2>Results</h2>
    <p>This is the Results page. Add your results information here.</p>
  </div>
);

export default Results;
